<template>
  <b-form @submit.prevent="getApplicantInfo">
    <b-card class="border0" style="padding-bottom: 15px;">
      <b-row>
        <b-col class="col-6">
          <label>이름</label>
          <b-form-input
            v-model="aptname"
            trim
            pattern=".{1,50}"
            title="최대 50자 이하로 입력해주세요"
            required
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>전화번호</label>
          <b-form-input
            v-model="aptmobilenum"
            trim
            pattern="^\d{3}-\d{4}-\d{4}$"
            title="ex) 010-1234-5678"
            required
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>이메일</label>
          <b-form-input
            v-model="aptemail"
            trim
            pattern="^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$"
            title="ex) abc@naver.com"
            required
          ></b-form-input>
        </b-col>
        <b-col class="col-6 searchBtnCol">
          <b-button class="searchBtn" type="submit">조회</b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card v-if="resultYn" class="border0" style="padding-top: 15px;">
      <b-row>
        <b-col class="col-6">
          <label>ID</label>
          <b-form-input
            ref="userId"
            v-model="userid"
            trim
            pattern=".{1,20}"
            title="최대 20자 이하로 입력해주세요"
            required
            :disabled="isAppCheck"
          ></b-form-input>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col class="col-6">
          <label>비밀번호</label>
          <b-form-input
            type="password"
            v-model="userpw"
            trim
            pattern=".{1,100}"
            title="최대 100자 이하로 입력해주세요"
            @input="checkPw"
            required
            :disabled="isAppCheck"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>비밀번호 확인</label>
          <b-form-input
            ref="userpwchk"
            type="password"
            v-model="userpwchk"
            trim
            pattern=".{1,100}"
            title="최대 100자 이하로 입력해주세요"
            @input="checkPw"
            required
            :disabled="isAppCheck"
          ></b-form-input>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col class="col-6">
          <label>이름</label>
          <b-form-input
            v-model="username"
            trim
            pattern=".{1,50}"
            title="최대 50자 이하로 입력해주세요"
            required
            :disabled="isAppCheck"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>전화번호</label>
          <b-form-input
            v-model="mobilenum"
            trim
            pattern="^\d{3}-\d{4}-\d{4}$"
            title="ex) 010-1234-5678"
            :disabled="isAppCheck"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>이메일</label>
          <b-form-input
            v-model="email"
            trim
            pattern="^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$"
            title="ex) abc@naver.com"
            :disabled="isAppCheck"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>회사 명</label>
          <b-form-input
            v-model="companyname"
            :disabled="isAppCheck"
          ></b-form-input>
          <!-- <b-form-select
            v-model="compid"
            :options="companyOptions"
            @change="chgCompany"
            :disabled="isAppCheck"
          ></b-form-select> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>회사 부서</label>
          <b-form-input
            v-model="companydept"
            trim
            pattern=".{1,50}"
            title="최대 50자 이하로 입력해주세요"
            :disabled="isAppCheck"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label>회사 직위</label>
          <b-form-input
            v-model="companypos"
            trim
            pattern=".{1,50}"
            title="최대 50자 이하로 입력해주세요"
            :disabled="isAppCheck"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label>회사 전화번호</label>
          <b-form-input
            v-model="officetel"
            trim
            pattern="^\d{2,4}-\d{3,4}-\d{4}$"
            title="ex) 042-523-1111"
            :disabled="isAppCheck"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="statRow">
        <div class="statDiv">
          <label>신청완료</label>
        </div>

        <b-col>=></b-col>

        <div class="statDiv">
          <label :style="processColor">처리중</label>
        </div>

        <b-col>=></b-col>

        <div class="statDiv">
          <label :style="completeColor">승인완료</label>
        </div>
      </b-row>
    </b-card>
    <div class="btnGrp">
      <div class="jcse">
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </b-form>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import utils from "./utils";
import moment from "moment";

export default {
  computed: {
    ...mapGetters(["getAlertOptions"]),
    processColor() {
      return this.approvalyn === "N" ? { backgroundColor: "yellow" } : { backgroundColor: "#fff" };
    },
    completeColor() {
      return this.approvalyn === "N" ? { backgroundColor: "#fff" } : { backgroundColor: "yellow" };
    },
  },
  data: () => ({
    aptname: null,
    aptmobilenum: null,
    aptemail: null,
    resultYn: false,
    isAppCheck: false,
    approvalyn: "N",
  }),
  created() {

  },
  mounted() {},
  methods: {
    ...mapMutations(["setAlertTitle"]),
    getApplicantInfo() {
      this.isAppCheck = true;
      var reqBody = {
        searchUsername: this.aptname,
        mobilenum: this.aptmobilenum,
        email: this.aptemail,
      };
      this.$http
        .post("/system/getApplicantInfo", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var count = res.data.aptCnt;
            if (count === 1) {

              this.resultYn = true;
              let userlist = res.data.data;
              this.userid = utils.chkStr(userlist[0].userid);
              this.username = utils.chkStr(userlist[0].username);
              this.mobilenum = utils.chkStr(userlist[0].mobilenum);
              this.email = utils.chkStr(userlist[0].email);
              this.companyname = utils.chkStr(userlist[0].companyname);
              // this.compid = utils.chkNum(userlist[0].compid);
              this.companydept = utils.chkStr(userlist[0].companydept);
              this.companypos = utils.chkStr(userlist[0].companypos);
              this.officetel = utils.chkStr(userlist[0].officetel);
              this.approvalyn = utils.chkStr(userlist[0].approvalyn);
              // this.grade = utils.chkStr(userlist[0].grade);
              // this.smsyn = utils.chkStr(userlist[0].smsyn);
              // this.emailyn = utils.chkStr(userlist[0].emailyn);
              // this.regdate = moment(userlist[0].regdate).format("YYYY-MM-DD");
            } else {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk("신청 내역이 없습니다.", this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            }
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    closeModal() {
      this.$bvModal.hide("applicationDetailModal");
    }
  }
}
</script>

<style lang="scss">
#applicationDetailModal .modal-dialog {
  max-width: 800px;

  .modal-content {

    .card {

      .card-body {
        border: 1px solid #7367f0;
        border-radius: 8px;

        .row {
          height: 50px;

          .statDiv {
            width: 30%;
            display: flex;
            justify-content: center;
            align-items: center;

            label {
              background-color: #fff;
            }
          }
          .col {
            padding: 10px 0;

            .chkIdBtn {
              background-color: #7367f0;
              border-color: #7367f0;
              padding: 6px 15px;
              color: #fff;
              border-radius: 5px;
            }

            &:first-child {
              padding-right: 10px;
            }
            &:last-child {
              padding-left: 10px;
            }
            &:only-child {
              padding-left: 0;
              padding-right: 0;
              &:not(.col-12) {
                padding-right: 10px;
              }
            }
            label {
              display: flex;
              align-items: center;
              width: 100px;
              height: 100%;
            }
          }
          .searchBtnCol {
            justify-content: flex-end;

            .searchBtn {
              width: 120px;
              background-color: #7367f0;
              border-color: #7367f0;
              color: #fff;
              border-radius: 5px;

              &:hover {
                background-color: #5344ed;
                border-color: #4839eb;
              }
            }
          }
        }
        .statRow {
          height: 80px;
          margin: 30px;

          .statDiv {
            width: 30%;
            display: flex;
            justify-content: center;
            align-items: center;

            label {
              height: 100%;
              width: 80px;
              margin: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              color: red;
              background-color: #fff;
            }
          }
        }
        .pwAlertMsg {
          height: auto;
          justify-content: flex-end;

          .col {
            justify-content: flex-end;
            padding: 0;
            font-size: 12px;

            span {
              color: #ffa500;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/ApplicationDetailModal.vue